import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { useInputPaddings } from './InputGroup.mjs';
import { inputClassNameBase } from './_common.mjs';
import { jsx } from 'react/jsx-runtime';

const ButtonInput = /*#__PURE__*/forwardRef(function ButtonInput({
  size = 'md',
  className,
  style,
  ...restProps
}, ref) {
  const inputPaddings = useInputPaddings();
  return /*#__PURE__*/jsx("button", {
    ref: ref,
    type: "button",
    className: clsx(className, inputClassNameBase({
      size
    }), 'np-button-input'),
    style: {
      ...inputPaddings,
      ...style
    },
    ...restProps
  });
});

export { ButtonInput };
//# sourceMappingURL=_ButtonInput.mjs.map
